import React, {useState} from 'react';
import utils from "../services/utils";
import Captchaaptcha from "./Captcha";
import managedata from "../services/managedata";
import CooldownButton from "./CooldownButton";
import logosidebar from "../style/imges/logosidebar.png";

const RegisterUserHub = (props) => {
    const [fName, setFNamee] = useState('');
    const [mail, setMail] = useState('');
    const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
    const [lName, setlName] = useState('');
    const [registerStep, setRegisterStep] = useState(1);
    const [otpCode, setOTP] = useState('');
    const [resultMsg, setResultMsg] = useState('');
    const [bueisCode, setBueisCode] = useState(utils.useLang('BUEIS_Code') + ' ' + utils.useLang('ASK_MANAGER'));

    async function registerSend(dataInfo) {
        try {
            let data = {
                authentication: {
                    key: utils.getToken(),
                    businessToken: utils.getBusToken(),
                },
                data:dataInfo,
                type: { act: 'registerUser' }
            };
            return await managedata.sendData(data,false,'sendBack')
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    }

    const handleRegister = async () => {
        try {
            let data = {
                    'phone': props.phoneNumber,
            }
            const res = await registerSend(data)
            if (res) {
                if(res.debug.statusCode === 415){
                    setResultMsg(utils.useLang('ACC_EXIST'))
                    setRegisterStep(3)
                }
                else setRegisterStep(2)
            }
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };

    function finishReg(){
        setResultMsg(utils.useLang('REGISTERED'));
        setRegisterStep(3);
    }

    const handleCompleteRegister =  () => {
        let data = {
            authentication: {
                key: utils.getToken(),
                businessToken: utils.getBusToken(),
            },
            'data': {
                "privateName": fName,
                "lastName": lName,
                "password": props.password,
                "email": mail,
                "otpCode": otpCode,
                'phone': props.phoneNumber,
            },
            'type': {'act': 'completeRegisterUser'}
        }
        managedata.sendData(data, false, finishReg)
    };

    return (
        <div className="login-box reg-box">
            <img className={'logo-sidebar logo-reg'} src={logosidebar} alt="logo"/>
            {registerStep === 1 && <div className={'register-info'}>
                <h2 className="login-title">{utils.useLang('REGISTER_HEAD')}</h2>
                <input
                    disabled
                    className="login-inp"
                    type="text"
                    placeholder={utils.useLang('BUEIS_Code')}
                    value={bueisCode}
                    onChange={(e) => setBueisCode(e.target.value)}
                />
                <input
                    className="login-inp"
                    type="text"
                    placeholder={utils.useLang('FIRST_NAME')}
                    value={fName}
                    onChange={(e) => setFNamee(e.target.value)}
                />
                <input
                    className="login-inp"
                    type="text"
                    placeholder={utils.useLang('LAST_NAME')}
                    value={lName}
                    onChange={(e) => setlName(e.target.value)}
                />
                <input
                    className="login-inp"
                    type="text"
                    placeholder={utils.useLang('EMAIL')}
                    value={mail}
                    onChange={(e) => setMail(e.target.value)}
                />
                <input
                    className="login-inp"
                    type="text"
                    placeholder={utils.useLang('PHONE_NUMBER')}
                    value={props.phoneNumber}
                    onChange={(e) => props.setPhoneNumber(e.target.value)}
                />
                <input
                    className="login-inp"
                    type="password"
                    placeholder={utils.useLang('PASS')}
                    value={props.password}
                    onChange={(e) => props.setPassword(e.target.value)}
                />
                <Captchaaptcha onVerify={setIsCaptchaVerified}/>
                {isCaptchaVerified && <button className="login-btn" onClick={handleRegister}>
                    {utils.useLang('REGISTER_BTN')}
                </button>}
                <div>
                    <button className="login-btn" onClick={() => props.setRegisterMode(false)}>
                        {utils.useLang('BACK')}
                    </button>
                </div>
            </div>}
            {registerStep === 2 && <div className={'register-approve-code'}>
                <input
                    className="login-inp"
                    type="text"
                    placeholder={utils.useLang('OTCODE')}
                    value={otpCode}
                    onChange={(e) => setOTP(e.target.value)}
                />
                <button className="login-btn" onClick={handleCompleteRegister}>
                    {utils.useLang('SEND')}
                </button>
                <CooldownButton
                    label={utils.useLang('SEND_CODE_AGAIN')}
                    onClick={handleCompleteRegister}
                />
            </div>}
            {registerStep === 3 && <div className={'register-conclusion'}>
                <div>
                    {resultMsg}
                </div>
                <button className="login-btn" onClick={() => props.setRegisterMode(false)}>
                    {utils.useLang('BACK')}
                </button>
            </div>}
        </div>
    );
};

export default RegisterUserHub;